<template>
    <div class="inner-wrap">
        <div class="left" :style="{'height': height}">
            <h1>Upload Print Images and Files</h1>
            <div class="mlist2">
                <div class="item" v-for="(v, k) in form_data.yinhua" :key="`ys` + k">
                    <div class="img-wrap ">
                        <Upload
                                :action="upload_url"
                                :data="{ dir: 'template' }"
                                :before-upload="(file)=>onBeforeUpload(file, 'yinhua', k, 'file')"
                                :show-upload-list="false"
                        >
                            <template v-if="!!!v.raw">
                                <div class="img-default cursor">
                                    <img class="img2" src="@/assets/images/design/icon-upload-pink.png"/>
                                    <p>Upload Print Image/File</p>
                                </div>
                            </template>
                            <template v-else-if="util.test_image(v.raw)">
                                <div class="image-box">
                                    <img @click.stop :src="v.raw" class="img" v-viewer />
                                    <div class="replace-btn">
                                        <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                        <div class="text">Re-upload</div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="doc-file">
                                <a class="" :href="v.raw" target="_blank" @click.stop>
                                    <img :src="util.get_image_icon(v.raw_name)" class="icon-doc" />
                                </a>
                                <div class="replace-file">
                                        <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                        <div class="text">Re-upload</div>
                                    </div>
                                </div>
                            </template>
                        </Upload>
                    </div>

                    <div class="r1">
                        <a class="name cursor" :href="v.raw" target="_blank">{{form_data.yinhua[k].raw_name}}</a>
                        <div class="tag-list">
                            <div class="tag-item" >
                                <span class="key" >Width (cm):</span>
                                <input class="value" :value="form_data.yinhua[k].x" @input="input2($event, 'yinhua', k, 'x')" placeholder="" type="text"/>
                            </div>
                            <div class="tag-item" >
                                <span class="key" >Height (cm):</span>
                                <input class="value" :value="form_data.yinhua[k].y" @input="input2($event, 'yinhua', k, 'y')" placeholder="" type="text"/>
                            </div>
                            <div class="tag-item">
                                <span class="key">Process:</span>
                                <select class="value" :value="form_data.yinhua[k].tech_name" @input="input2($event, 'yinhua', k, 'tech_name')">
                                    <option value="">Please select process</option>
                                    <option v-for="(vvv,kkk) in yinhua_list" :value="vvv.name" :key="`yyhh-`+kkk">{{vvv.name}}</option>
                                </select>
                            </div>
                            <div class="tag-item" >
                                <span class="key">Number of Colors:</span>
                                <select class="value" :value="form_data.yinhua[k].color" @input="input2($event, 'yinhua', k, 'color')">
                                    <option value="">Please select color count</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label >Usage Instructions</label>
                        <input :value="form_data.yinhua[k].desc" @input="input2($event, 'yinhua', k, 'desc')" placeholder="Usage Instructions" class="desc" type="text"/>
                    </div>
                    <img src="@/assets/images/design/icon-del.png" class="icon-del cursor" @click.prevent="del_yinhua(k)" />
                </div>

                <div class="btn-continue cursor" @click="add_yinhua">
                    + Add Print Pattern
                </div>
            </div>

        </div>

        <div class="right" :style="{width: width}" >
            <template v-if="is_lesson_show">
                <Lesson ></Lesson>
            </template>
            <template v-else>
                <div class="material-wrap" :style="{'height': height, overflow: 'auto'}">
                    <div class="top">
                        <h2>Print Process Selection</h2>
                        <div class="input-wrap">
                            <input v-model="form_data_yinhua.keyword" placeholder="Enter keywords to search print processes" type="text" @keyup.enter="search_yinhua"/>
                            <img alt="" class="icon-search" src="@/assets/images/icon-search.png" @click="search_yinhua"/>
                        </div>
                    </div>
                    <div class="content">
                        <div class="right">
                            <template v-if="yinhua_list.length > 0">
                                <div class="fabric-list">
                                    <div
                                            v-for="(v, k) in yinhua_list"
                                            :key="`df` + k"
                                            :class="{ active: current_temp_yinhua.id === v.id }"
                                            class="fabric-item"
                                            @click="open_color_modal(v)"
                                    >
                                        <img :src="v.image | default_img" alt="" />
                                        <p>{{ v.name }}</p>
                                        <img v-show="current_temp_yinhua.id === v.id" alt="" class="icon-check" src="@/assets/images/icon-check.png"/>
                                        <div class="mask">
                                            <div class="btn">
                                                <span class="fa-detail" @click.stop="open_yinhua_detail(v)">View</span>
                                                <span class="fa-choose" @click.stop="add_yinhua(v)">Select</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Page :current="form_data_yinhua.page" v-if="total>0" :page-size="form_data_yinhua.size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  ></Page>
                            </template>
                            <template v-else>
                                <img class="no-data" :src="require(`@/assets/images/no-data.png`)" alt="">
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <popup :show.sync="is_popup_show_detail" height="680px" width="980px" @on-close="close_yinhua_detail">
            <div class="fabric-content-wrap" style="height:100% !important;">
                <div class="title">{{ current_temp_yinhua.name }}</div>
                <div class="info-wrap">
                    <div class="left-popup">
                        <div v-if="current_temp_yinhua.image_list && current_temp_yinhua.image_list.length > 0" class="slider">
                            <swiper ref="swiper" :options="swiperOption">
                                <swiper-slide
                                        v-for="(item, index) in current_temp_yinhua.image_list"
                                        :key="`sl` + index"
                                >
                                    <img v-viewer :src="item.url" class="img" />
                                </swiper-slide>
                                <div slot="button-prev" class="swiper-button-prev"></div>
                                <div slot="button-next" class="swiper-button-next"></div>
                            </swiper>
                        </div>
                    </div>
                    <div class="right" v-html="current_temp_yinhua.description">
                        
                    </div>
                </div>
            </div>
        </popup>

    </div>
</template>

<script>
    import util from '@/utils/util'
    import {mapState} from 'vuex'
    import {
        GetYXTech
    } from "@/api/index.js";
    import Lesson from "./Lesson.vue";
    import { uploadFileToOSS } from "@/utils/oss";
    import Popup from "@/components/Popup.vue";
    import "swiper/dist/css/swiper.css";
    import { swiper, swiperSlide } from "vue-awesome-swiper";

    export default {
        name: "Yinhua",
        data() {
            return {
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                util: util,
                form_data_yinhua: {
                    page: 1,
                    size: 20,
                    keyword: "",
                    type: 2,
                },
                total: -1,
                yinhua_list: [],
                current_temp_yinhua: {},
                is_popup_show_detail: false,
                is_color_show: false,
                width: '600px',
                swiperOption: {
                    loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true, //修改swiper的父元素时，自动初始化swiper
                },
            }
        },
        components: {
            Lesson,Popup,swiper,swiperSlide
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                height: (state) => state.design.height,
                is_lesson_show: (state) => state.design.is_lesson_show,
            }),
        },
        methods: {
            close_yinhua_detail() {
                this.reset_temp_yinhua()
                this.is_popup_show_detail = false;
            },
            open_yinhua_detail(v){
                console.log('yinhuadetail',v);
                this.current_temp_yinhua = Object.assign({},v);
                this.is_popup_show_detail = true;
            },
            changePage(page) {
                this.form_data_yinhua.page = page
                this.getYinhuaList()
            },
            open_color_modal(yinhua) {
                this.current_temp_yinhua = Object.assign({}, yinhua);
            },
            add_yinhua(v) {
                let object = {image: "", content: "", raw: "", raw_name: "", x: "", y: "", tech_name: v ? v.name: '', color: "",}
                this.$store.commit("design/arr_push_one", {key: 'yinhua', value: object})
                this.reset_temp_yinhua()
            },
            del_yinhua(k) {
                this.$DModal.confirm({
                    content: 'Do you want to cancel this data?',
                    okText:'Confirm',
                    cancelText:'Cancel',
                    onOK: async () => {
                        this.$store.commit('design/arr_remove_one', {key: 'yinhua', index: k})
                    }
                })

            },
            reset_temp_yinhua() {
                this.current_temp_yinhua = {};
            },
            search_yinhua() {
                this.getYinhuaList();
            },
            async getYinhuaList() {
                return GetYXTech({
                    ...this.form_data_yinhua,
                }).then((response) => {
                    this.yinhua_list = response.data.list;
                    this.total = response.data.total;
                    return response;
                });
            },
            input2($event, field, k, child_field) {
                let object = this.form_data[field][k]
                object[child_field] = $event.target.value
                this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
            },
            onBeforeUpload(file, field, k, child_field) {
                uploadFileToOSS(file, 'template').then(url => {
                    let object = this.form_data[field][k]
                    if (child_field === "file") {
                        object.raw = url;
                        object.raw_name = file.name;
                    } else if (child_field === "image") {
                        object.image = url;
                    }
                    this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
                })
                return false;
            },
        },
        mounted() {
            this.width = window.innerWidth - 220 - 490 - 30 + 'px'
            this.getYinhuaList();
        }
    }
</script>

<style scoped lang="scss">
    .inner-wrap {
        display: flex;
        flex-wrap: nowrap;

        .left {
            padding: 0 30px 100px 30px;
            width: 490px;
            background: white;
            overflow: auto;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            .tab-list {
                margin-top: 20px;
                width: 100%;
                padding-bottom: 15px;
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                border-bottom: 1px solid #E6E6E6;
                .tab-item {
                    color: #4D4D4D;
                    font-size: 16px;
                    text-align: center;
                    &.active {
                        font-weight: bold;
                        color: black;
                        font-size: 18px;
                    }
                }
                .shu {
                    width: 2px;
                    height: 20px;
                    background: #808080;
                }
            }
            h1 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 18px;
                color: #000000;
                border-left: 2px solid black;
                padding-left: 10px;
                margin: 15px 0;
            }

            .tip3 {
                margin: 20px 0 10px 0;
                font-weight: bolder;
                font-size: 14px;
                color: red;
            }


            .mlist2 {
                display: flex;
                flex-wrap: wrap;
                .item {
                    position: relative;
                    width: 420px;
                    height: 200px;
                    margin-bottom: 10px;
                    padding: 10px;
                    border: 1px solid #BFBFBF;
                    border-radius: 5px;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    .img-wrap {
                        position: relative;
                        width: 120px;
                        height: 120px;
                        background: #F5F5F5;
                        .icon-doc {
                            width: 120px;
                            height: 120px;
                            object-fit: cover;
                        }
                        .img-default {
                            width: 120px;
                            height: 120px;
                            display: flex;
                            justify-content: center;
                            align-content: center;
                            flex-wrap: wrap;
                            .img2 {
                                width: 22px;
                                height: 22px;
                            }
                            p {
                                color: #FA3D5A;
                                width: 100%;
                                text-align: center;
                            }
                        }
                        .img {
                            width: 120px;
                            height: 120px;
                            object-fit: contain;
                        }
                        .image-box{
                            width: 120px;
                            height: 120px;
                            position:relative;
                            .img {
                                    width: 120px;
                                    height: 120px;
                                    object-fit: contain;
                                }
                            .replace-btn{
                                width:100px;
                                position:absolute;
                                bottom:11px;
                                left:50%;
                                transform:translateX(-50%);
                                background:rgba(0,0,0,0.4);
                                color:#ffffff;
                                font-size:13px;
                                display:flex;
                                align-items:center;
                                justify-content:center;
                                cursor:pointer;
                                .ico{
                                    width:18px;
                                    height:18px;
                                    // color:#ffffff;
                                }
                                .text{}
                            }
                        }
                        .doc-file{
                    display:flex;
                    align-items:center;
                   position:relative;
                   width:100%;
                    .replace-file{
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        width:100px;
                        position:absolute;
                        bottom:11px;
                        left:50%;
                        transform:translateX(-50%);
                        background:rgba(0,0,0,0.4);
                        color:#ffffff;
                        font-size:13px;
                        cursor:pointer;
                        .ico{
                            width:18px;
                            height:18px;
                        }
                    }
                }
                    }
                    .r1 {
                        width: 260px;
                        display: flex;
                        flex-wrap: wrap;
                        margin-left: 10px;
                        .name {

                            color: #1D1D1D;
                            font-weight: bold;
                        }
                        .tag-list {
                            display: flex;
                            flex-wrap: wrap;
                            align-content: flex-start;
                            .tag-item {
                                width: 100%;
                                border-bottom: 1px solid #E6E6E6;
                                display: flex;
                                flex-wrap: nowrap;
                                align-items: center;
                                .key {
                                    width: 100px;
                                    color: #666;
                                }
                                .value {
                                    height: 30px;
                                    color: #1A1A1A;
                                    border: none;
                                    outline: none;
                                }
                                select {
                                    border: none;
                                    outline: none;
                                }
                            }
                        }
                    }

                    .form-group {
                        width: 400px;
                        height: 40px;
                        padding: 0 10px;
                        background: #F5F5F5;
                        border-radius: 5px;
                        display: flex;
                        align-items: center;
                        .desc {
                            background: #F5F5F5;
                            margin-left: 10px;
                            width: 300px;
                            height: 40px;
                            line-height: 40px;
                            border: none;
                            outline: none;
                        }
                    }

                    .icon-del {
                        position: absolute;
                        top: 6px;
                        right: 6px;
                        width: 18px;
                        height: 18px;
                    }
                }
                .btn-continue {
                    width: 420px;
                    height: 55px;
                    line-height: 55px;
                    color: #666666;
                    font-size: 14px;
                    text-align: center;
                    margin: 10px 0;
                    border-radius: 10px;
                    border: 1px solid #ccc;
                }
            }
        }

        .right {
            margin: 0 auto;
            .material-wrap {
                margin-top: 10px;
                margin-right: 50px;
                padding: 10px;
                background: white;
                .top {
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 5px;
                    border-bottom: 2px solid #f6f7fa;
                    h2 {
                        font-size: 20px;
                        color: #1a1a1a;
                        white-space: nowrap;
                    }

                    .input-wrap {
                        margin-left: 50px;
                        width: 280px;
                        height: 35px;
                        position: relative;

                        &:focus {
                            border: none !important;
                        }

                        &::after {
                            border: none !important;
                        }

                        input {
                            width: 100%;
                            height: 100%;
                            background: #f2f2f2;
                            border-radius: 17px;
                            padding: 0 45px 0 20px;
                            border: none !important;

                            &:focus {
                                border: none !important;
                            }

                            &::after {
                                border: none !important;
                            }
                        }

                        .icon-search {
                            position: absolute;
                            right: 18px;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 20px;
                            height: 20px;
                            cursor: pointer;
                        }
                    }
                }

                /* 主内容区 */
                .content {
                    display: flex;

                    /* 左侧分类 */
                    .category-list {
                        width: 100px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        align-content: flex-start;
                        border-right: 1px solid #f6f7fa;
                        overflow-y: auto;
                        padding: 15px 0;

                        .category-item {
                            width: 80px;
                            height: 35px;
                            line-height: 35px;
                            text-align: center;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #1C1C1C;
                            border-radius: 5px;
                            &.active {
                                background: #1C1C1C;
                                color: white;
                                font-weight: 500;
                            }
                        }
                    }

                    /* 右侧内容 */
                    .right {
                        $left_width: 140px;
                        width: calc(100% - #{$left_width});
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        padding: 10px;
                        overflow: hidden;

                        /* 标签筛选区 */
                        .label-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 12px 0;
                            margin-bottom: 5px;

                            .label-item {
                                padding: 0 15px;
                                height: 30px;
                                line-height: 30px;
                                border-radius: 15px;
                                //   background: #f6f6f6;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #ffecee;
                                    color: #fa3d5a;
                                    font-weight: 500;
                                }
                            }
                        }

                        /* 子分类 */
                        .sub-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 10px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                            background: #f6f6f6;

                            .sub-item {
                                padding: 0 12px;
                                height: 28px;
                                line-height: 28px;
                                border-radius: 14px;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #fa3d5a;
                                    color: white;
                                }
                            }
                        }

                        .no-data {
                            width:300px;
                            height: auto;
                            display: block;
                            margin:0 auto;
                        }
                        .fabric-list {
                            flex: 1;
                            display: grid;
                            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
                            border-radius: 5px;
                            // gap: 3px 0px;
                            gap: 6px 55px;
                            align-items: start;
                            overflow-y: auto;
                            height:auto;
                            max-height:650px;
                            padding: 15px;
                            background: #F6F7FA;

                            &::-webkit-scrollbar {
                                display: none !important;
                            }

                            .fabric-item {
                                position: relative;
                                //width: 142px;
                                flex:0 0 20%;
                                height: 175px;
                                margin: 0 5px 15px 5px;
                                cursor: pointer;
                                box-sizing: border-box;
                                border: 1px solid #e3e4e6;
                                border-radius: 5px;

                                img {
                                    // width: 140px;
                                    width:100%;
                                    height: 141px;
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;
                                    object-fit: cover;
                                }

                                p {
                                    // width: 140px;
                                    width: 100%;
                                    height: 30px;
                                    line-height: 30px;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    background: white;
                                    padding: 0 5px;
                                    border-top: 0.5px solid #e3e4e6;
                                    margin-top: -5px;
                                    text-align: center;
                                    border-bottom-left-radius: 5px;
                                    border-bottom-right-radius: 5px;
                                }

                                .icon-check {
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    width: 25px;
                                    height: 25px;
                                }

                                &.active {
                                    border: 1px solid #fa3d5a;
                                }

                                .mask {
                                    display: none;
                                }

                                &:hover {
                                    .mask {
                                        display: block;
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        right: 0;
                                        height: 140px;
                                        z-index: 100;
                                        background: rgba(0, 0, 0, 0.35);

                                        .btn{
                                            display:flex;
                                            align-items:center;
                                            justify-content:end;
                                            position: absolute;
                                            right: 10px;
                                            top: 115px;
                                            column-gap:10px;
                                            .fa-detail {
                                                z-index: 101;
                                                color: white;
                                                font-weight: bold;
                                            }

                                            .fa-choose {
                                                z-index: 101;
                                                color: white;
                                                font-weight: bold;
                                            }
                                        }
                                        
                                    }
                                }
                            }
                        }

                        /* 底部按钮 */
                        .btn-group {
                            display: flex;
                            justify-content: flex-end;
                            gap: 15px;
                            padding-top: 10px;

                            .btn {
                                min-width: 100px;
                                height: 38px;
                                line-height: 38px;
                                border-radius: 5px;
                                cursor: pointer;
                                transition: all 0.2s;
                                text-align: center;

                                &.btn-cancel {
                                    color: black;
                                    border: 1px solid #e5e5e5;
                                }

                                &.btn-confirm {
                                    color: white;
                                    background: #fa3d5a;
                                }
                            }
                        }
                    }
                }

                .color-mask {
                    position: absolute;
                    top: 0;
                    right: 0;
                    left: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.35);
                    z-index: 9999;
                    .color-wrap {
                        position: absolute;
                        width: 600px;
                        height: 300px;
                        top:calc(50% - 150px);
                        left: calc(50% - 300px);
                        background: white;
                        border-radius: 10px;
                        z-index: 10000;
                        padding: 20px 10px 0 10px;

                        .title {
                            font-size: 16px;
                            font-weight: bold;
                            color: #1a1a1a;
                        }

                        .color-list {
                            display: flex;
                            flex-wrap: wrap;
                            width: 560px;
                            min-height: 150px;

                            .color-item {
                                width: 120px;
                                height: 46px;
                                border: 1px solid #e5e5e5;
                                border-radius: 5px 5px 5px 5px;
                                margin: 0 8px;
                                display: flex;
                                align-items: center;
                                padding: 0 5px;
                                cursor: pointer;

                                img {
                                    width: 30px;
                                    height: 30px;
                                    margin-right: 5px;
                                }

                                &.active {
                                    border-color: #fa3d5a;

                                    span {
                                        color: #fa3d5a;
                                    }
                                }
                            }
                        }

                        .btn-group {
                            margin-top: 24px;
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;
                            border-top: 1px solid #e5e5e5;
                            height: 58px;

                            .btn {
                                width: 100px;
                                height: 38px;
                                line-height: 38px;
                                border-radius: 5px;
                                text-align: center;
                                font-size: 14px;
                                margin: 0 7px;
                                cursor: pointer;

                                &.btn-cancel {
                                    color: black;
                                    border: 1px solid #e5e5e5;
                                }

                                &.btn-confirm {
                                    color: white;
                                    background: #fa3d5a;
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    @media (min-width:1280px) and (max-width:1679px){
        .inner-wrap{
            min-width:1200px;
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:auto;
                min-width:400px;
                max-width:450px;
                margin-right:10px;
                height:100% !important;
                .mlist2{
                    width:100%;
                    .btn-continue{
                        width:100%;
                        max-width:450px;
                    }
                    .item{
                        width:100%;
                        // flex-wrap:nowrap;
                        .r1{
                            width:auto !important;
                            max-width:230px;
                            .tag-list{
                                width:100%;
                                .tag-item{
                                    .value{
                                        width:120px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .right{
                margin:0;
                // width:auto !important;
                flex:1 1 auto;
                // min-width:600px;
                // max-width:1100px;
                flex-shrink:0;
                margin-right:0;
                height:100%;
                .material-wrap{
                    width:100%;
                }
            }
        }
    }
    @media (max-width:1279px){
        .inner-wrap{
            min-width:1200px;
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:auto;
                min-width:400px;
                max-width:450px;
                margin-right:10px;
                height:100% !important;
                .mlist2{
                    width:100%;
                    .btn-continue{
                        width:100%;
                        max-width:450px;
                    }
                    .item{
                        width:100%;
                        // flex-wrap:nowrap;
                        .r1{
                            width:auto !important;
                            max-width:230px;
                            .tag-list{
                                width:100%;
                                .tag-item{
                                    .value{
                                        width:120px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .right{
                margin:0;
                // width:auto !important;
                flex:1 1 auto;
                // min-width:600px;
                // max-width:1100px;
                flex-shrink:0;
                margin-right:0;
                height:100%;
                .material-wrap{
                    width:100%;
                }
            }
        }
    }


    ::v-deep .popup-modal {
        /* 核心容器 */
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
        background: rgba(0, 0, 0, 0.6);

        /* 弹窗内容区 */
        .popup-content {
            background: #fff;
            border-radius: 10px;
            //   width: min(980px, 92vw); // 最大980px，最小占92%视口宽
            /* 修正后 */
            width: max(980px, 96vw); // 增加视口占比
            min-width: 320px; // 保障最小可操作宽度
            max-width: none !important; // 移除潜在限制

            /* 添加边距保护 */
            margin: 0 2vw; // 左右留白
            box-sizing: content-box; // 防止padding影响
            max-height: max(720px, 85vh); // 最大720px，最小占85%视口高
            height: 30vh;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
    }

    .fabric-content-wrap {
        margin-top: 40px;
        overflow-y: scroll;
        height: 600px;
        display:flex;
        flex-direction:column;
        .title {
            color: #1a1a1a;
            font-size: 16px;
            border-left: none;
            font-weight: bold;
            margin-bottom: 0;
            padding: 10px 0;
            height: auto;
            width:100%;
            text-align:center;
            padding-bottom:18px;
            border-bottom:1px solid #ebebeb;
            margin-bottom:30px;
        }

        .info-wrap {
            display: flex;
            justify-content: space-around;

            .left {
                width: 420px;

                .f-img {
                    width: 420px;
                    height: 420px;
                }
            }

            .right {
                width: 500px;

                .name {
                    color: #1a1a1a;
                    font-size: 20px;
                }

                .no {
                    color: #808080;
                    font-size: 14px;
                    margin: 25px 0;
                }

                .item {
                    margin: 5px 0;

                    .key {
                        display: inline-block;
                        color: #808080;
                        width: 80px;
                    }

                    .value {
                        color: #1a1a1a;
                    }
                }
            }
        }

        .richtext-wrap {
        }
    }

    .slider {
        width: 420px;
        height: 420px;
        overflow: hidden;

        .swiper-slide {
            width: 420px;
            height: 420px;
        }

        .img {
            width: 420px;
            height: 420px;
        }
    }
</style>
